/**
 * Torn weapon bonuses from https://wiki.torn.com/wiki/Weapon_Bonus
 * Used for search filter dropdown.
 */
export const WEAPON_BONUSES = [
  'Achilles', 'Assassinate', 'Backstab', 'Berserk', 'Bleed', 'Blindfire', 'Blindside',
  'Bloodlust', 'Burn', 'Comeback', 'Conserve', 'Cripple', 'Crusher', 'Cupid', 'Deadeye',
  'Deadly', 'Demoralize', 'Disarm', 'Double-edged', 'Double Tap', 'Emasculate', 'Empower',
  'Eviscerate', 'Execute', 'Expose', 'Finale', 'Focus', 'Freeze', 'Frenzy', 'Fury',
  'Grace', 'Hazardous', 'Home run', 'Irradiate', 'Lacerate', 'Motivation', 'Paralyze',
  'Parry', 'Penetrate', 'Plunder', 'Poison', 'Powerful', 'Proficiency', 'Puncture',
  'Quicken', 'Rage', 'Revitalize', 'Roshambo', 'Shock', 'Sleep', 'Slow', 'Smash',
  'Smurf', 'Specialist', 'Spray', 'Storage', 'Stricken', 'Stun', 'Suppress',
  'Sure Shot', 'Throttle', 'Toxin', 'Warlord', 'Weaken', 'Wind-up', 'Wither',
].sort((a, b) => a.localeCompare(b));
